/* IMPORTANT: Before modifying this file, please update CHANGELOG.md with a summary of your changes.
Also, make clear comments about every change in this file and what it was replacing so that we don't end up trying the same fixes repeatedly. */

import React, { useRef } from 'react';

interface ResultsProps {
  markdown: string | null;
  isVisible: boolean;
}

const Results: React.FC<ResultsProps> = ({ markdown, isVisible }) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  if (!isVisible || !markdown) return null;

  const copyToClipboard = () => {
    if (textAreaRef.current) {
      textAreaRef.current.select();
      document.execCommand('copy');
      alert('Copied to clipboard!');
    }
  };

  const downloadMarkdown = () => {
    const element = document.createElement('a');
    const file = new Blob([markdown], { type: 'text/markdown' });
    element.href = URL.createObjectURL(file);
    element.download = 'api-integration-instructions.md';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Integration Instructions</h2>
      
      <div className="bg-gray-50 p-4 rounded-md mb-4 overflow-auto max-h-96">
        <pre className="whitespace-pre-wrap text-sm text-gray-700 font-mono">{markdown}</pre>
      </div>
      
      <textarea
        ref={textAreaRef}
        value={markdown}
        readOnly
        className="sr-only"
      />
      
      <div className="flex flex-wrap gap-4 justify-center">
        <button
          onClick={copyToClipboard}
          className="px-4 py-2 bg-blue-600 text-white font-medium rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
          </svg>
          Copy to Clipboard
        </button>
        
        <button
          onClick={downloadMarkdown}
          className="px-4 py-2 bg-green-600 text-white font-medium rounded-md shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          Download as .md
        </button>
      </div>
    </div>
  );
};

export default Results;